export default __webpack_public_path__ + "static/media/icon_member.f7b7bb00.svg";